import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './MatchScreen.css';

const MatchScreen = ({ user1, user2, matchId, onClose }) => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    console.log('user1:', user1);
    console.log('user2:', user2);
    console.log('matchId:', matchId);

    const handleSendMessage = () => {
        // Navigate to messages with the conversation ID
        navigate(`/chat/${matchId}`);
        onClose();
    };

    return (
        <div className="match-screen-overlay">
            <div className="match-screen-content">
                <div className="match-header">
                    <h1>{t('match.congrats')}</h1>
                </div>
                
                <div className="match-photos">
                    <div className="photo-container">
                        <img src={user1.photos[0]?.photoUrl} alt={t('match.yourProfile')} className="profile-photo user1" />
                        <img src={user2.photos[0]?.photoUrl} alt={t('match.matchProfile')} className="profile-photo user2" />
                    </div>
                </div>

                <div className="match-text">
                    <h2>{t('match.itsAMatch')}</h2>
                </div>

                <div className="match-actions">
                    <button 
                        className="btn-send-message"
                        onClick={handleSendMessage}
                    >
                        {t('match.sendMessage')}
                    </button>
                    
                    <button 
                        className="btn-continue"
                        onClick={onClose}
                    >
                        {t('match.continue')}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default MatchScreen;
